import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface CampaignState {
  language: 'en' | 'tet' | 'pt';
  setLanguage: (lang: 'en' | 'tet' | 'pt') => void;

  selectedDonationAmount: number | null;
  setSelectedDonationAmount: (amount: number | null) => void;

  isMobileMenuOpen: boolean;
  setMobileMenuOpen: (isOpen: boolean) => void;

  completedActions: string[];
  addCompletedAction: (action: string) => void;

  notifications: Array<{ id: string; message: string; type: 'success' | 'error' | 'info' }>;
  addNotification: (notification: Omit<CampaignState['notifications'][0], 'id'>) => void;
  removeNotification: (id: string) => void;
}

export const useCampaignStore = create<CampaignState>()(
  persist(
    (set) => ({
      language: 'en',
      setLanguage: (lang) => set({ language: lang }),

      selectedDonationAmount: null,
      setSelectedDonationAmount: (amount) => set({ selectedDonationAmount: amount }),

      isMobileMenuOpen: false,
      setMobileMenuOpen: (isOpen) => set({ isMobileMenuOpen: isOpen }),

      completedActions: [],
      addCompletedAction: (action) => 
        set((state) => ({ 
          completedActions: [...state.completedActions, action] 
        })),

      notifications: [],
      addNotification: (notification) => 
        set((state) => ({
          notifications: [
            ...state.notifications,
            { ...notification, id: Math.random().toString(36).substr(2, 9) }
          ]
        })),
      removeNotification: (id) =>
        set((state) => ({
          notifications: state.notifications.filter((n) => n.id !== id)
        })),
    }),
    {
      name: 'campaign-storage',
      partialize: (state) => ({ 
        language: state.language,
        completedActions: state.completedActions 
      }),
    }
  )
);